import { defineMessages } from 'react-intl';

export default defineMessages({
    docsCompleteHeading: {
        id: '_.outstanding_view.topup_form.docsCompleteHeading',
        defaultMessage: 'Thanks for your application'
    },
    docsCompleteDescription: {
        id: '_.outstanding_view.topup_form.docsCompleteDescription',
        defaultMessage: `We'll aim to get back to you in 24 hours but please bear with us if we take a little longer.`
    },
    backToDashboard: {
        id: '_.outstanding_view.topup_form.backToDashboard',
        defaultMessage: 'Back to dashboard'
    },
    errorHeading: {
        id: '_.outstanding_view.topup_form.errorHeading',
        defaultMessage: 'Oops, it looks like something went wrong'
    },
    errorCTA: {
        id: '_.outstanding_view.topup_form.errorCTA',
        defaultMessage: 'Get in touch'
    }
});
